<div>
  <button mat-button (click)="submit()">{{ 'COMMON.SAVE' | translate }}</button>
  <button mat-button (click)="editDishesList()">{{ 'MENU.PROMO.EDIT_LIST' | translate }}</button>
  <span *ngIf="loading">
        {{ 'COMMON.LOADING' | translate }}
  </span>
  <div class="dish-list" cdkDropList (cdkDropListDropped)="dropProduct($event)">
    <app-menu-section-product *ngFor="let product of products"
                              [currency]="currency"
                              [product]="product"
                              [originalProduct]="doNothing(product)"
                              (editProduct)="doNothing($event)"
                              [menuSection]="menuSection"
                              [currentOrganization]="currentOrganization"
                              [cdkDragData]="product"
                              [menuPipes]="menuPipes"
                              [showKioskWarning]="showKioskWarning"
                              cdkDrag
                              class="drag-box">
      <div *cdkDragPlaceholder class="product-drag-placeholder"></div>
    </app-menu-section-product>
  </div>
</div>
